import React from 'react';

import Typography, { VariantProps } from '../../library/typography/typography';

import { getProductPriceDetails } from '../../shared/utils/product/product';

import { PriceInfoProps } from '../../shared/types/product';
import { HYBRIS_UNIT_NAME } from '../../shared/constants/units';

import './price.scss';

interface PriceProps extends PriceInfoProps, VariantProps {
  className?: string;
  isPriceForEach?: boolean;
  isPriceFromMinPrice?: boolean;
  quantity?: number;
  seePriceInCartMessage?: string;
  unitName?: string | null;
}

function Price(props: PriceProps) {
  const {
    className,
    isPriceForEach = true,
    isPriceFromMinPrice = false,
    mapPrice,
    price,
    priceRange,
    seePriceInCartMessage = 'See price in cart',
    unitName,
    variant
  } = props;

  const {
    displayPrice,
    displayPriceForEach: detailsDisplayPriceForEach,
    hasPriceRange = false
  } = getProductPriceDetails({
    isPriceFromMinPrice,
    mapPrice,
    price,
    priceRange,
    seePriceInCartMessage
  });
  const displayPriceForEach = Boolean(
    detailsDisplayPriceForEach && isPriceForEach
  );

  return (
    <Typography
      className={`price ${
        displayPrice === seePriceInCartMessage ? 'price--see-in-cart' : ''
      } ${className}`}
      styleName="price"
      tag="span"
      variant={variant ? variant : 'H5'}
      weight="black"
    >
      {hasPriceRange && isPriceFromMinPrice && (
        <Typography size="extraSmall" styleName="from" tag="span" weight="bold">
          from{' '}
        </Typography>
      )}
      {displayPrice}
      <Typography className="price__unit" styleName="unit" tag="span">
        {displayPriceForEach && unitName
          ? ` /${HYBRIS_UNIT_NAME[unitName]}`
          : ''}
      </Typography>
    </Typography>
  );
}

export default Price;
